import React, {Fragment} from "react";
import MetisMenu from 'react-metismenu';
import RouterLink from 'react-metismenu-router-link';


function DashboardNav(props) {
    return (
        <Fragment>
            {props.onHeadingClick ? (
                <h5
                    className="app-sidebar__heading d-flex align-items-center justify-content-between"
                    style={{ cursor: 'pointer' }}
                    onClick={props.onHeadingClick}
                    title="Hide menu"
                >
                    {props.heading}
                    <i className="pe-7s-angle-left" style={{ fontSize: '1.4rem' }} />
                </h5>
            ) : (
                <h5 className="app-sidebar__heading">{props.heading}</h5>
            )}
            <MetisMenu
                content={props.menuItems}
                // activeLinkId
                activeLinkFromLocation
                className="vertical-nav-menu"
                iconNamePrefix=""
                classNameStateIcon="pe-7s-angle-down"
                LinkComponent={RouterLink}
            />
        </Fragment>
    );
}

export default DashboardNav;
